const blockConfig = {
  height: 60,
  popoverWidth: 660,
  stepsWidth: 500,
  smallHeight: 30,
  padding: 4,
  radius: 4,
  showAs: {
    tentative: 'tentative',
    complete: 'complete',
    disabled: 'disabled',
  },
  arrows: {
    left: 'left',
    right: 'right',
    both: 'both',
  },
  types: {
    absence: 'absence',
    reservation: 'reservation',
    fieldService: 'field_service',
    placeholder: 'placeholder',
  },
  alertsBySeverity: {
    0: {
      badgeText: 'OK',
      level: 'None',
    },
    1: {
      badgeText: 'OK',
      level: 'Success',
    },
    2: {
      badgeText: 'OK',
      level: 'Low',
    },
    3: {
      badgeText: 'WARNING',
      level: 'Medium',
    },
    4: {
      badgeText: 'ERROR',
      level: 'High',
    },
  },
  alert: {
    success: {
      icon: 'check-circle',
      text: 'ok',
      colorMain: '#3C85C9',
      colorTravel: '#BFD7ED',
      colorStatus: '#6BC93C',
      priority: 1,
    },
    low: {
      icon: 'check-circle',
      text: 'ok',
      colorMain: '#3C85C9',
      colorTravel: '#BFD7ED',
      colorStatus: '#6BC93C',
      priority: 1,
    },
    medium: {
      icon: 'exclamation-triangle',
      text: 'warning',
      colorMain: '#F5A623',
      colorTravel: '#F9C56E',
      colorStatus: '#F5A623',
      priority: 2,
    },
    high: {
      icon: 'exclamation-circle',
      text: 'action',
      colorMain: '#C93C3C',
      colorTravel: '#DC7F7F',
      colorStatus: '#C93C3C',
      priority: 3,
    },
    none: {
      colorMain: '#3C85C9',
      colorTravel: '#BFD7ED',
    },
  },
  absenceColor: {
    main: '#ba2c91',
    light: 'rgba(186, 44, 145, 0.3)',
  },
  reservationColor: {
    main: '#3C85C9',
  },
  routeOptimisationColor: {
    main: '#3C85C9',
    light: '#BFD7ED',
  },
  inactiveColor: {
    main: '#B2C1CF',
  },
  isDraft: {
    color: '#F5A623',
    errorColor: '#CC0000',
    icon: 'exchange-alt',
  },
  lock: {
    color: '#64747c',
    icon: 'lock',
    draftIcon: 'syncLock',
  },
  colors: {
    default: '#3C85C9',
    complete: '#B2C1CF',
  },
  statusesView: {
    full: 0,
    one: 1,
    two: 2,
  },
  blockActions: {
    publishToSAP: 'publish',
    markDateConfirmed: 'markDateConfirmed',
    editPlanning: 'editPlanning',
    deletePlanning: 'delete',
    viewPlanning: 'viewPlanning',
    showSteps: 'showSteps',
    savePlanning: 'savePlanning',
    splitBlock: 'splitJob',
    restoreBackup: 'restoreBackup',
    markDateUnconfirmed: 'markDateUnconfirmed',
    recalculateTravelTime: 'recalculateTravelTime',
    abortRouteOptimisation: 'abortRouteOptimization',
    retryRouteOptimisation: 'retryRouteOptimization',
  },
  activityTypes: {
    travelFrom: 'travelFrom',
    travelTo: 'travelTo',
    labour: 'labour',
    work: 'work',
    nonWork: 'nonWork',
  },
  blockSeverities: {
    NONE: 0,
    HIGH: 1,
    MEDIUM: 2,
    LOW: 4,
    INFO: 3,
    SUCCESS: 4,
  },
};

export default blockConfig;
